import { useMemo } from 'react';
import { Contact } from '@/types/crm';
import { calculatePersona, getPersonaPresentation } from '@/lib/leadAnalysis';

export function usePersona(lead: Contact, score?: number) {
  const personaKey = useMemo(() => calculatePersona(lead, score), [lead, score]);
  const persona = useMemo(() => getPersonaPresentation(personaKey), [personaKey]);

  return {
    personaKey,
    persona,
  };
}
